module.exports = __webpack_public_path__ + "9296ae30c0508775f6c1fe5b22f13d53.png";